export type PageStripLayout = number[];

export const enum PaginationCoreMode {
  Pages = 'pages',
  Compact = 'compact',
  Input = 'input',
}

export enum DataHooks {
  currentPage = 'current-page',
  totalPages = 'total-pages',
  slashLabel = 'slash-label',
  pageCompact = 'page-compact',
  pageForm = 'page-form',
  pageStrip = 'page-strip',
  pageInput = 'page-input',
  previous = 'previous',
  next = 'next',
  first = 'first',
  last = 'last',
  page = 'page',
}
